import { createContext, useContext, type ReactNode } from "react";

/* The active agent slice. An agent is selected by route (/agents/:agentId), not
 * by a filter control, so the workspace provides it here and the analytics
 * hooks merge it into the query as `agent_id`. Null outside a workspace (home,
 * cross-agent aggregate, and the config library), where no agent filter is
 * applied. This keeps every existing analytics page agent-scoped with no edits —
 * they just read the same global query, now narrowed by one extra filter. */
const AgentScopeContext = createContext<string | null>(null);

export function AgentScopeProvider({
  agentId,
  children,
}: {
  agentId: string | null;
  children: ReactNode;
}) {
  return (
    <AgentScopeContext.Provider value={agentId}>
      {children}
    </AgentScopeContext.Provider>
  );
}

/** The agent_id pinning the current view, or null when unscoped. */
export function useAgentScope(): string | null {
  return useContext(AgentScopeContext);
}
